module.exports = __webpack_public_path__ + "img/Asian_Quinoa Bowl_Tofu.4c5f0ec0.jpg";